import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

const ErrorPage: React.FC = () => {
	const [isHover, setIsHover] = React.useState(false);

	return (
		<div
			style={{
				minHeight: "100vh",
				padding: "28px",
				background: "linear-gradient(180deg, #f7f9fc 0%, #eef2f7 100%)",
			}}
		>
			<Link
				to="/"
				onMouseEnter={() => setIsHover(true)}
				onMouseLeave={() => setIsHover(false)}
				style={{
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					width: "42px",
					height: "42px",
					borderRadius: "50%",
					border: "1px solid #d9dde6",
					backgroundColor: isHover ? "#ffffff" : "#f6f8fc",
					color: "#1f2937",
					fontSize: "18px",
					transform: isHover ? "translateX(-2px)" : "translateX(0)",
					boxShadow: isHover ? "0 6px 20px rgba(31, 41, 55, 0.12)" : "none",
					transition: "all 0.2s ease",
				}}
			>
				<ArrowLeftOutlined />
			</Link>

			<div
				style={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					textAlign: "center",
					minHeight: "calc(100vh - 98px)",
				}}
			>
				<div
					style={{
						backgroundColor: "#ffffff",
						borderRadius: "20px",
						padding: "36px 40px",
						boxShadow: "0 12px 30px rgba(15, 23, 42, 0.08)",
						maxWidth: "700px",
						width: "100%",
					}}
				>
					<img
						src="https://khicindekocvar.blob.core.windows.net/cdn/prod/footer-koc-logo.png"
						alt="KocLogo"
						style={{ maxWidth: "350px", width: "100%", height: "auto", marginBottom: "10px" }}
					/>
					<h2 style={{ margin: 0, marginBottom: "10px", color: "#111827" }}>Beklenmedik bir hata oluştu.</h2>
					<p style={{ margin: 0, color: "#4b5563", fontSize: "16px" }}>Lütfen daha sonra tekrar deneyin.</p>
				</div>
			</div>
		</div>
	);
};

export default ErrorPage;
